import React, { useState, useEffect } from 'react';
import './App.scss';

import Contact from './Contact'
import Footer from './Footer'
import Nav from './Nav'
import Portfolio from './Portfolio'
import Profile from './Profile'
import Social from './Social'
import StaticTop from './StaticTop'

import * as staticItems from '../folio_items.json'

function App() {
  const [ready, setReady] = useState(false)
  const [items, setItems] = useState([])

  useEffect(() => {
    if (window.location.hostname === 'localhost') {
      console.log('local')
      const itemsUrl = '/items'
      const opts = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }
      fetch(itemsUrl, opts)
        .then(res => res.json())
        .then(items => {
          console.log({ items, staticItems: staticItems.default })
          setItems(items)
          setReady(true)
        })
        .catch(console.error)
    } else {
      setItems(staticItems.default)
      setReady(true)
    }

  }, [])

  return (
    <div className="App">
      {
        ready
          ? <>
              <Nav />
              <StaticTop show={true} />
              <Portfolio setReady={setReady} items={items} setItems={setItems} />
              <Profile />
              <Social />
              <Contact />
              <Footer />
              {/* <div style={{ height: '1000px' }}></div> */}
            </>
          : 'Loading...'
      }
    </div>
  );
}

export default App;
